import {Directive, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Directive({
  selector: '[intDateController]'
})
export class DateControllerDirective implements OnChanges {

  @Input() date: Date | null = new Date();

  pluginDate = new Date();

  @Output() onSelect = new EventEmitter<Date>()

  change$ = new BehaviorSubject<Date>(this.pluginDate);

  constructor() {
    if(this.date !== null) {
      this.update(this.date)
    }
  }

  updateState(date: Date) {
    this.date = date;
    this.pluginDate = date;
    this.change$.next(date);
  }

  update(date: Date) {
    this.pluginDate = date;
    this.change$.next(date);
  }

  getPluginDateParams() {
    return {
      year: this.pluginDate.getFullYear(),
      month: this.pluginDate.getMonth(),
      day: this.pluginDate.getDate()
    }
  }

  getInputDateParams() {
    return {
      year: this.date?.getFullYear(),
      month: this.date?.getMonth(),
      day: this.date?.getDate()
    }
  }

  setYear(year: number) {
    const {day, month} = this.getPluginDateParams();
    const date = new Date(year, month, day);
    this.update(date);
  }

  setMonth(month: number) {
    const {day, year} = this.getPluginDateParams();
    const date = new Date(year, month, day);
    this.update(date);
  }

  setDay(day: number) {
    const {month, year} = this.getPluginDateParams();
    const date = new Date(year, month, day);
    this.update(date);
  }

  ngOnChanges() {
    this.change$.next(this.pluginDate);
  }
}
